import React, { Component } from "react";
import ReportCard from "./ReportCard";
import Header from "../../../Common/Component/Header";
import Sidebar from "../../../Common/Component/Sidebar";
class ReportCardList extends Component {
  state = {search_value: ""};

  loadReport = (id) => {
    this.props.history.push(`/reports/report`, { query: { 'id': id } })
  }

  render() {
    const { search_value } = this.state;
    let authUser = JSON.parse(localStorage.getItem('authUser'));
    const logged_in_user_role = authUser?.user?.user_roles?.map(x => x.name);
    const is_franchise_owner = logged_in_user_role?.includes('franchise_owner');

    return (
      <div id="wrapper">
        <div className="content-area">
          {/* Header */}
          <Header
            placeholder={"Acc Number, Customer Address or Contact Details"}
            search_value={search_value}
          />

          {/* Sidebar */}
          <Sidebar />
          <div className="block-row">
            <div className="flist">
              <ReportCard 
                key="7"
                title="Cancellation Report"
                description="This report will show all customers who have been deactivated, along with their reason for cancelation."
                loadReport={this.loadReport}
                id="customer-cancelation-report"
              />
              
              <ReportCard 
                key="0"
                title="Price Increase Report"
                description="This report will show all customers who are ready for a price increase, with batch options to select individual customers."
                loadReport={this.loadReport}
                id="customer_price_increase_report"
              />

              <ReportCard 
                key="1"
                title="Customer Statement"
                description="This report will show a invoice status and history of payments."
                loadReport={this.loadReport}
                id="customer_statement"
              />
              <ReportCard 
                key="2"
                title="Commercial Sales Report"
                description="This report will show all sales of revenue, addons and repairs by franchise."
                loadReport={this.loadReport}
                id="commercial_sales_report"
              />

              <ReportCard 
                key="3"
                title="Customer Complaints Report"
                description="This report will show an overview of all complaints by franchise."
                loadReport={this.loadReport}
                id="customer_complaints_report"
              />

              <ReportCard 
                key="4"
                title="Daily Log Report"
                description="This report will show all daily logs and activity performed within franchises and by customer service rep."
                loadReport={this.loadReport}
                id="daily_log_report"
              />

              <ReportCard 
                key="5"
                title="In Territory Revenue Reports"
                description="This report will show all customers that are interested in a service that is not yet serviced or owned."
                loadReport={this.loadReport}
                id="in_territory_revenue_reports"
              />

              <ReportCard 
                key="6"
                title="Job Completed to Invoiced Reconciliation Report"
                description="This report will show the amount of work that was invoiced compared to the amount of work that was completed for a given time period."
                loadReport={this.loadReport}
                id="invoice_revenue_report"
              />

              {
                !is_franchise_owner ?
                  <ReportCard 
                    key="8"
                    id="royalty-report"
                    title="Royalty Report"
                    description="This report will show all revenue minus discounts by franchise and territory."
                    loadReport={this.loadReport}
                  /> : null
              }

              <ReportCard 
                key="9"
                title="Lead and Sign Up Report"
                description="This report will display the data of all customers and Residential leads/Commercial proposals."
                loadReport={this.loadReport}
                id="lead_signup_report"
              />

              <ReportCard 
                key="10"
                title="Coupon Code Report"
                description="This report will display the coupons used by the customers with the franchise breakdown and invoiced value of the coupon code (Residential Customers only)."
                loadReport={this.loadReport}
                id="coupon_report"
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ReportCardList;
